import React from "react";
import styled from "styled-components";
import { useNavigate,useLocation } from "react-router-dom";
import viv from "../../assets/products/Vivretab.png";
import sara from "../../assets/products/SARATab.png";
import blink from "../../assets/products/Blinkstab.png";
import hospitality from "../../assets/products/Hospitalitytab.png";
import NewFooter from "../../components/NewFooter/NewFooter";
import { Stack, Typography } from "@mui/material";
import TiltImg from "../../components/imageTilted/tiltImage";
import { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import img6 from "../../assets/products/car1.png";
import img7 from "../../assets/products/car2.png";
import img8 from "../../assets/products/car3.png";
import img9 from "../../assets/products/car4.jpg";
import TiltCarousel from "../../components/tiltCarousel/tiltCarousel";

// Styled Components - Fixed syntax errors
const GradientText = styled.h2`
  font-size: 2.8rem;
  margin: 0 0 30px 0;
  text-align: center;
  padding: 1rem;
background: #ffffff;
background: linear-gradient(103deg,rgba(255, 255, 255, 1) 0%, rgba(59, 150, 255, 1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  
  animation: colorChange 5s infinite;
  @keyframes colorChange {
    0% {
      background-position: 0% 0%;
    }
    50% {
      background-position: 100% 100%;
    }
    100% {
      background-position: 0% 0%;
    }
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const BoldText = styled.span`
  font-weight: bold;
  color: #fff;
`;

const Section = styled.div`
  margin-bottom: 15px;
  font-size: 1rem;
  color: #fff;
  line-height: 1.6;
`;

const CenterAlignedSection = styled(Section)`
  text-align: center;
  font-size: 1.1rem;
  margin-bottom: 25px;
`;

const ProductList = styled.div`
  display: flex;
  margin-top:70px;
  flex-direction: column;
  gap: 0;
  overflow:hidden !important;
  padding: 80px 0;
  max-width: 100%;
  background: black;
   borderRadius:20px;
`;

const ProductItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 600px;
  align-items: center;
  background: black;
  
  ${({ reverse }) => reverse && `
    grid-template-columns: 1fr 1fr;
    direction: rtl;
    * {
      direction: ltr;
    }
  `}

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    min-height: auto;
    direction: ltr;
    text-align: center; /* Center content on mobile */
    * {
      direction: ltr;
    }
  }
`;

const ImageSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
 
  
  @media (max-width: 1024px) {
    order: -1;
    padding: 30px 20px;
    justify-content: center; /* Ensure centering on mobile */
    width: 100%;
    overflow: hidden; /* Prevent TiltImg from breaking layout */
  }
  
  @media (max-width: 768px) {
    padding: 20px 10px;
    /* Constrain TiltImg on mobile */
    & > * {
      max-width: 100% !important;
      width: auto !important;
      height: auto !important;
    }
  }
`;

const BannerImage = styled.img`
  width: 90%;
  max-width: 450px;
  height: auto;
  object-fit: cotain;

  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 350px;
  }
`;

const ProductContent = styled.div`
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 0.15) 20%,
    rgba(255, 255, 255, 0.05) 80%
  );
  backdrop-filter: blur(10px);
  border-radius: 25px;
  margin: 40px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    padding: 40px 30px;
    margin: 20px;
    border-radius: 20px;
    text-align: center; /* Center text on tablets */
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
    margin: 10px; /* Reduce margin on mobile */
    text-align: center; /* Center all content on mobile */
  }
`;

const ProductDescription = styled.div`
  font-size: 1rem;
  color: #fff;
  margin-bottom: 40px;
  
  @media (max-width: 768px) {
    text-align: left; /* Keep description left-aligned for readability */
    margin-bottom: 30px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: auto;
`;

const ViewMoreButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 15px 30px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 35px rgba(102, 126, 234, 0.4);
  }

  &:active {  
    transform: translateY(-1px);
  }
`;

const ArrowIcon = styled.svg`
  width: 20px;
  height: 20px;
  margin-left: 10px;
  fill: white;
  transition: transform 0.3s ease;
  
  ${ViewMoreButton}:hover & {
    transform: translateX(5px);
  }
`;

const ListTitle = styled.div`
  font-weight: bold;
  color: #fff;
  margin-bottom: 20px;
  font-size: 1.1rem;
`;

const BulletPoints = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-bottom: 20px;
  margin-top: 20px;
  
  @media (max-width: 768px) {
    text-align: left; /* Keep bullet points left-aligned */
  }
`;

const ListItem = styled.li`
  display: flex;
  align-items: flex-start;
  line-height: 1.7;
  margin-bottom: 12px;
  padding-left: 20px;
  position: relative;

  &::before {
   
    color: #667eea;
    font-weight: bold;
    font-size: 1.2rem;
    margin-right: 12px;
    flex-shrink: 0;
    margin-top: 2px;
    position: absolute;
    left: 0;
  }
`;

// TiltImg Wrapper to control mobile behavior
const TiltImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  
  
  @media (max-width: 1024px) {
    /* Ensure TiltImg doesn't break mobile layout */
    max-width: 100%;
    overflow: hidden;
    
    /* Override TiltImg dimensions on mobile */
    & > * {
      max-width: 300px !important;
      max-height: 400px !important;
      width: 300px !important;
      height: 400px !important;
    }
  }
  
  @media (max-width: 768px) {
    & > * {
      max-width: 250px !important;
      max-height: 350px !important;
      width: 250px !important;
      height: 350px !important;
    }
  }
  
  @media (max-width: 480px) {
    & > * {
      max-width: 200px !important;
      max-height: 300px !important;
      width: 200px !important;
      height: 300px !important;
    }
  }
`;

const products = [
  {
    name: "Vivre",
    logo: "https://source.unsplash.com/random/80x80?logo",
    description: (
      <>
        <CenterAlignedSection>
          <BoldText>
            Experience Manager for Unified Multi-Platform UI/UX Customization
          </BoldText>
        </CenterAlignedSection>

        <ul style={{ paddingLeft: "0" }}>
          <li>Vivre enables real-time UI/UX customization across multiple platforms, seamlessly integrating with any CMS.</li>
          <li><strong>Faster Launch:</strong> Reduce development time and launch products quickly.</li>
          <li><strong>Tailor the Screen on the Fly:</strong> Customize layouts in real-time.</li>
          <li><strong>Launch Across 12+ Platforms:</strong> Deploy simultaneously to multiple platforms.</li>
          <li><strong>Unique Brand Experience:</strong> Deliver a standout, personalized interface.</li>
          <li><strong>Rich Templates:</strong> Use high-quality, visually appealing templates.</li>
          <li><strong>Boost Engagement:</strong> Intuitive discovery and binge-watching features.</li>
          <li><strong>Pre-integrated SDKs:</strong> Save time with pre-built third-party integrations.</li>
        </ul>
      </>
    ),
    banner: viv,
    link: "/product/vivre",
    gradientStart: "#FF7E5F",
    gradientEnd: "#FF6F61",
    images: [
      require("../../assets/Home/vivre1.png"),
      require("../../assets/Home/vivre2.png"),
      require("../../assets/Home/vivre4.png"),
      require("../../assets/Home/vivre5.png"),
    ],
  },

  {
    name: "Content Eye",
    logo: "https://source.unsplash.com/random/80x80?ai,media",
    description: (
      <>
        <CenterAlignedSection>
          <BoldText>AI-Driven Content Intelligence & Governance Platform</BoldText>
        </CenterAlignedSection>

        <ul style={{ paddingLeft: "0" }}>
          <li>Deep multimodal analysis across video, audio, images, and documents at enterprise scale.</li>
          <li><strong>Agentic AI Workflows:</strong> Autonomous AI agents manage validation, enrichment, and optimisation with human editorial oversight.</li>
          <li><strong>Content Quality Checks:</strong> Automated detection of technical, visual, audio, and editorial issues.</li>
          <li><strong>Metadata Intelligence:</strong> Frame-level insights, semantic tagging, and evolving metadata generation.</li>
          <li><strong>Compliance & Governance:</strong> Enforces broadcast rules, GDPR, CCPA, accessibility, and regional regulations.</li>
          <li><strong>Monetisation Enablement:</strong> Supports licensing, safe reuse, contextual ad placement, and long-tail value discovery.</li>
          <li><strong>Facial & Object Recognition:</strong> Advanced face, object, and scene detection with comparison and verification.</li>
          <li><strong>Timeline-Synced Search:</strong> Instantly locate exact moments, scenes, or entities across large archives.</li>
          <li><strong>Cloud-Native Backbone:</strong> Serverless, event-driven architecture powered by Horizon MediaLake.</li>
          <li><strong>Secure & Scalable:</strong> Enterprise-grade security, auditability, and elastic scaling.</li>
        </ul>
      </>
    ),
    banner: blink,
    link: "/product/contentEye",
    gradientStart: "#6A5ACD",
    gradientEnd: "#7B68EE",
    images: [
      require("../../assets/products/car1.png"),
      require("../../assets/products/car2.png"),
      require("../../assets/products/car3.png"),
      require("../../assets/products/car4.jpg"),
    ],
  },

  {
    name: "ReelCraft",
    logo: "https://source.unsplash.com/random/80x80?video",
    description: (
      <>
        <CenterAlignedSection>
          <BoldText>Professional Video Creation & Editing Platform</BoldText>
        </CenterAlignedSection>

        <ul style={{ paddingLeft: "0" }}>
          <li>Tools for creating professional-grade videos with real-time collaboration and cloud rendering.</li>
          <li><strong>Group Recommendations:</strong> Content tailored to your group's preferences.</li>
          <li><strong>Smart Search:</strong> Fast, accurate search across all content.</li>
          <li><strong>Personalized Engagement:</strong> Adapts to each user's viewing habits.</li>
          <li><strong>Mood-Aware:</strong> Suggests content for your mood.</li>
          <li><strong>Auto-Reframing:</strong> Converts videos to vertical formats.</li>
          <li><strong>Smart Summaries:</strong> Condensed storylines and AI tags.</li>
          <li><strong>Chapterization:</strong> Auto chapters and timestamps.</li>
          <li><strong>Multi-Language Dubbing:</strong> Instant localization in multiple languages.</li>
          <li><strong>Quality Control:</strong> Checks for visual and playback issues.</li>
        </ul>
      </>
    ),
    banner: blink,
    link: "/product/reelcraft",
    gradientStart: "#FF7E5F",
    gradientEnd: "#FF6F61",
    images: [
      require("../../assets/reelcraft/image (1).jpg"),
      require("../../assets/reelcraft/image (2).jpg"),
      require("../../assets/reelcraft/image (3).jpg"),
    ],
  },

  {
    name: "S.A.R.A",
    logo: "https://source.unsplash.com/random/80x80?service",
    description: (
      <>
        <CenterAlignedSection>
          <BoldText>AI-Powered OTT Recommendation Engine</BoldText>
        </CenterAlignedSection>

        <ul style={{ paddingLeft: "0" }}>
          <li>SARA processes large content datasets to provide analytics-driven recommendations that boost engagement and retention.</li>
          <li><strong>Performance Monitoring:</strong> Monitor on-screen performance</li>
          <li><strong>Engagement:</strong> Personalized push notifications</li>
          <li><strong>Revenue Growth:</strong> Drive content upsell</li>
          <li><strong>Customer Experience:</strong> Improve customer experience</li>
          <li><strong>Analytics:</strong> Advanced search statistics</li>
          <li><strong>Insights:</strong> Automated trend analysis</li>
          <li><strong>Recommendations:</strong> Multiple recommendation types</li>
        </ul>
      </>
    ),
    banner: sara,
    link: "/product/sara",
    gradientStart: "#FF7E5F",
    gradientEnd: "#FF6F61",
    images: [
      require("../../assets/sara/insight1.png"),
      require("../../assets/sara/insight2.png"),
      require("../../assets/sara/insight3.png"),
      require("../../assets/sara/insight4.png"),
      require("../../assets/sara/Retention-1.png"),
      require("../../assets/sara/Retention-2.png"),
      require("../../assets/sara/Retention-3.png"),
    ],
  },

  {
    name: "AdPilot",
    logo: "https://source.unsplash.com/random/80x80?ads",
    description: (
      <>
        <CenterAlignedSection>
          <BoldText>Advanced Advertisement Management Platform</BoldText>
        </CenterAlignedSection>

        <ul style={{ paddingLeft: "0" }}>
          <li>AI-powered ad management to optimize targeting, placement, and revenue generation across platforms.</li>
          <li><strong>Smart Ad Targeting:</strong> Deliver personalized ads.</li>
          <li><strong>Revenue Optimization:</strong> Maximize returns with smart bidding.</li>
          <li><strong>Cross-Platform Integration:</strong> Centralized ad management.</li>
          <li><strong>Analytics Dashboard:</strong> Track and analyze performance.</li>
        </ul>
      </>
    ),
    banner: blink,
    link: "/product/adpilot",
    gradientStart: "#FF7E5F",
    gradientEnd: "#FF6F61",
    images: [
      require("../../assets/adpilot/adpilot1.png"),
      require("../../assets/adpilot/adpilot2.png"),
      require("../../assets/adpilot/adpilot3.png"),
    ],
  },

  {
    name: "Horizon Hospitality Suite",
    logo: "https://source.unsplash.com/random/80x80?hotel",
    description: (
      <>
        <CenterAlignedSection>
          <BoldText>Future of OTT Entertainment in Hospitality</BoldText>
        </CenterAlignedSection>

        <ul style={{ paddingLeft: "0" }}>
          <li>Horizon Broadband offers a turnkey OTT/IPTV Hospitality Suite designed for hotels to deliver personalized in-room entertainment.</li>
          <li><strong>Live & On-Demand:</strong> Customizable entertainment options for guests.</li>
          <li><strong>Easy to Use:</strong> Simple interface for operators and hotels.</li>
          <li><strong>Secure:</strong> DRM and CRM integrations for safe media delivery.</li>
          <li><strong>Compatible:</strong> Works with ATV, STB, and dongle devices.</li>
        </ul>
      </>
    ),
    banner: hospitality,
    link: "/product/hospitality",
    gradientStart: "#FF7E5F",
    gradientEnd: "#FF6F61",
    images: [
      require("../../assets/Hospititlity/0.jpg"),
      require("../../assets/Hospititlity/1.jpg"),
      require("../../assets/Hospititlity/2.jpg"),
      require("../../assets/Hospititlity/3.jpg"),
      require("../../assets/Hospititlity/4.jpg"),
      require("../../assets/Hospititlity/5.jpg"),
      require("../../assets/Hospititlity/6.jpg"),
      require("../../assets/Hospititlity/7.jpg"),
    ],
  },

  {
    name: "Blinks",
    logo: "https://source.unsplash.com/random/80x80?entertainment",
    description: (
      <>
        <CenterAlignedSection>
          <BoldText>Blinks – Short Video Creation & Sharing Platform</BoldText>
        </CenterAlignedSection>

        <ul style={{ paddingLeft: "0" }}>
          <li>Empower users to create, share, and monetize short-form videos with advanced social and engagement tools.</li>
          <li><strong>Content Creation:</strong> Tools for creating and sharing short videos.</li>
          <li><strong>Monetization:</strong> Ad-based revenue opportunities.</li>
          <li><strong>Influencer Growth:</strong> Community-driven expansion.</li>
          <li><strong>Ultra Low Latency:</strong> Instant video playback.</li>
          <li><strong>Gamification & Contests:</strong> Increase user interaction.</li>
          <li><strong>Content Moderation:</strong> Safe and compliant environment.</li>
          <li><strong>Live Broadcasting:</strong> Real-time streaming for audiences.</li>
        </ul>
      </>
    ),
    banner: blink,
    link: "/product/blink",
    gradientStart: "#FF7E5F",
    gradientEnd: "#FF6F61",
    images: [
      require("../../assets/Blinks/Frame 16.png"),
      require("../../assets/Blinks/Frame 17.png"),
      require("../../assets/Blinks/poster.png"),
    ],
  },
];





const AllProducts = () => {
  const navigate = useNavigate();
  const location=useLocation();

  const handleViewMore = (link) => {
    navigate(link);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
    });
  }, []);

  return (
    <>
      <ProductList>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Typography
            data-aos="zoom-in"
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "39px",
              fontWeight: "800",
              fontFamily: "system-ui",
              color: "#6054E4",
            }}
          >
            Products
          </Typography>
        </div>
        {products.map((product, index) => (
          <ProductItem key={index} reverse={index % 2 !== 0} index={index}>
            <ImageSection>
<TiltCarousel images={product.images}/>
            </ImageSection>
            <ProductContent 
              data-aos={(index % 2 !== 0) ? "slide-right" : "slide-left"}  
              reverse={index % 2 !== 0}
            >
              <GradientText
                gradientStart={product.gradientStart}
                gradientEnd={product.gradientEnd}
              >
                {product.name}
              </GradientText>
              <ProductDescription>{product.description}</ProductDescription>
              <ButtonWrapper>
                <ViewMoreButton onClick={() => handleViewMore(product.link)}>
                  View More
                  <ArrowIcon
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path d="M10.59 16.59L15.17 12 10.59 7.41 12 6l6 6-6 6-1.41-1.41z" />
                  </ArrowIcon>
                </ViewMoreButton>
              </ButtonWrapper>
            </ProductContent>
          </ProductItem>
        ))}
      </ProductList>
      <NewFooter />
    </>
  );
};

export default AllProducts;